import * as React from 'react';

import { SmartbotAIConnectionStore } from './SmartbotAIConnectionStore';
import {
  SmartbotAIConnectionStoreContext,
  SmartbotAIConnectionStoreProvider
} from './context';

const useSmartbotAIConnectionStore = (): SmartbotAIConnectionStore => {
  const smartbotAIConnectionStoreContext = React.useContext(
    SmartbotAIConnectionStoreContext
  );

  return smartbotAIConnectionStoreContext.store as SmartbotAIConnectionStore;
};

export {
  SmartbotAIConnectionStore,
  useSmartbotAIConnectionStore,
  SmartbotAIConnectionStoreProvider
};
